import {
  AdminAccountForm,
  CreateAdminAccountBody,
  UpdateAdminAccountBody,
} from '../types';

export const adminAccountBodyAdapter = (
  adminAccount: AdminAccountForm,
): CreateAdminAccountBody => ({
  identificationTypeId: adminAccount.identificationTypeId,
  identification: adminAccount.identification,
  countryId: adminAccount.countryId,
  name: adminAccount.names,
  birthday: adminAccount.birthdate
    ? new Date(adminAccount.birthdate).toISOString().split('T')[0]
    : '',
  paternalLastName: adminAccount.lastnamePather,
  maternalLastName: adminAccount.lastnameMother,
  email: adminAccount.email,
  personalEmail: adminAccount.personalEmail,
  phone: adminAccount.phone,
  nationalityId: adminAccount.nationality?.value,
});

export const adminAccountUpdateBodyAdapter = (
  values: AdminAccountForm,
): UpdateAdminAccountBody => ({
  id: values.id,
  name: values.names,
  maternalLastName: values.lastnameMother,
  paternalLastName: values.lastnamePather,
  birthday: values.birthdate
    ? new Date(values.birthdate).toISOString().split('T')[0]
    : '',
  nationalityId: values.nationality?.value,
  email: values.email,
  personalEmail: values.personalEmail,
  phone: values.phone,
  rolesId: values.role?.value as number,
});
